import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

import {
  CustomerOrganizationTypeSchema,
  OrganizationDomainInsertModelSchema,
} from './organization.models.ts'
import { UserDomainInsertModelSchema } from './user.models.ts'

export const OrganizationSignUpModelSchema =
  OrganizationDomainInsertModelSchema.pick({
    name: true,
    websiteUrl: true,
  }).extend({
    organizationType: CustomerOrganizationTypeSchema,
  })

export const UserSignUpModelSchema = UserDomainInsertModelSchema.pick({
  firstName: true,
  lastName: true,
  emailAddress: true,
})

export const SignUpModelSchema = z.object({
  user: UserSignUpModelSchema,
  organization: OrganizationSignUpModelSchema,
})

export type SignUpModel = ZodInfer<typeof SignUpModelSchema>
